import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { useHistory } from 'react-router-dom'
import UseTranslation from '../../../hooks/UseTranslation'
import {
  approveNotificationRequestFinish,
  rejectNotificationRequestFinish,
  selectApproveFinishModalData,
  selectRejectFinishModalData,
} from '../../../utils/finishDataContiner'
import FormModalContainer from '../../../components/Modals/FormModalContainer'
import GenericBtn from '../../../components/Buttons/OfoqThemeBtn'
import successImage from '../../../images/success.svg'
import { notificationsInboxActions } from '../../../redux/features/notifications/notificationInbox/notificationInboxThunk'
import OfoqTextArea from '../../../components/Forms/OfoqTextArea'
import appRoutes from '../../../services/AppRoutes'
import FinishModalContainerV2 from '../../../components/Modals/FinishModalContainerV2'

const ActionNotificationFormModal = ({
  modalStatus,
  setModalStatus,
  data,
  actionAfterSuccess,
}) => {
  const { t } = UseTranslation()
  const isApprove = modalStatus.type === 'approve'
  const [requestFinish, setRequestFinish] = useState(false)
  const [comment, setComment] = useState('')
  const dispatch = useDispatch()
  const history = useHistory()

  const handleNotificationRequestForm = () => {
    dispatch(
      notificationsInboxActions(
        {
          action: isApprove ? 'approve' : 'reject',
          queries: {
            id: data?.id,
            comment,
          },
        },
      ),
    ).then((res) => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        setRequestFinish(true)
        cancelHandler()
      }
    })
  }
  const cancelHandler = () => {
    setComment('')
    setModalStatus({
      status: false,
      type: modalStatus.type,
    })
  }
  const finishModalHandler = () => {
    setRequestFinish(false)
    if (actionAfterSuccess) {
      actionAfterSuccess()
    }
  }

  return (
    <Box data-testid="action-notification-modal">
      <FormModalContainer
        modalTitle={isApprove
          ? `${t?.[approveNotificationRequestFinish.header]}`
          : `${t?.[rejectNotificationRequestFinish.header]}`}
        modalState={modalStatus.status}
        handleClose={cancelHandler}
        customWidth={styles.form}
        customStyle={styles.modalContainer}
        cancelText={t?.Close}
      >
        <Box>
          <Box sx={styles.formContainer}>
            <Typography sx={styles.title}>
              {t?.['Are you sure you want to']}
              <span style={isApprove ? styles.approveStyle : styles.rejectStyle}>
                { isApprove ? t?.APPROVE : t?.Reject}
              </span>
              <span>
                { ` ${t?.THIS} `}
              </span>
              {` ${data?.source_type?.value || ''} ${t?.['Requested By']} ${data?.employee?.name || ''} ${t?.['?']}`}
            </Typography>
            <OfoqTextArea
              name={t?.['Add Comment']}
              customPlaceHolder={t?.['Type your comment Here']}
              refState={setComment}
              defaultValue={comment}
              customStyle={styles.textArea}
            />

          </Box>

          <Box sx={styles.btnsContainer}>
            <GenericBtn customStyle={styles.cancelBtn} name={`${t?.No}`} onClick={cancelHandler} cancelStyle />
            <GenericBtn
              name={isApprove ? `${t?.[approveNotificationRequestFinish.ApproveText]}`
                : `${t?.[rejectNotificationRequestFinish.ApproveText]}`}
              onClick={() => {
                handleNotificationRequestForm()
              }}
              customStyle={styles.sendBtn}
            />
          </Box>
        </Box>

      </FormModalContainer>
      <FinishModalContainerV2
        modalState={requestFinish}
        modalData={isApprove ? selectApproveFinishModalData : selectRejectFinishModalData}
        actionAfterSuccess={finishModalHandler}
        modalIcon={successImage}
        mediumSize
        formModalStyle
        mobileModalStyle
        cancelText={t?.Close}
        customStyle={styles.finishModalContainer}
        disappearCancelButton
      >
        <Box sx={styles.modalMsg}>
          <Typography sx={styles.modalMsgText} variant="heading4">
            {t?.['You can monitor the status of this action in the']}
            <Typography
              component="span"
              sx={styles.modalMsgSpan}
              onClick={() => {
                setRequestFinish(false)
                history.push(appRoutes.ActionHistory)
              }}
            >
              {t?.['Action History Screen']}
            </Typography>
          </Typography>
        </Box>
      </FinishModalContainerV2>
    </Box>
  )
}

const styles = {
  form: {
    xs: 'initial',
    sm: '450px',
    md: '521px',
  },
  formContainer: {
    p: '10px',
  },
  modalContainer: {
    '& div': {
      maxHeight: { sm: '100%' },
    },
  },

  btnsContainer: {
    display: 'flex',
    marginLeft: 'auto',
    justifyContent: 'flex-end',
    padding: { xs: '0 16px', sm: '10px 16px 0 16px' },
    margin: { xs: '0px  -16px 0px -16px', sm: '0 -16px' },
    borderTop: { xs: 'none', sm: '1px solid #dddddd' },
  },
  sendBtn: {
    marginLeft: { xs: 'unset', sm: '10px' },
    maxWidth: { xs: '100%', sm: '150px' },
  },
  cancelBtn: {
    display: { xs: 'none', sm: 'block' },
    marginLeft: { xs: 'unset', sm: '10px' },
    width: { xs: '100%', sm: '96px' },
    minWidth: { xs: '80px', sm: '96px' },
    textAlign: 'center',
  },
  title: {
    fontSize: '16px',
    my: '20px',
  },
  approveStyle: {
    color: '#29CC8B',
  },
  rejectStyle: {
    color: '#FC5A5A',
  },
  finishModalContainer: {
    '& .message': {
      mb: { xs: '10px', sm: '20px' },
      fontSize: { xs: '14px', sm: '18px' },
    },
    '& .close-btn': {
      '& svg': { display: 'block' },
    },
  },
  modalMsg: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    mt: '-20px',
  },
  modalMsgText: {
    color: 'grey.500',
    paddingRight: '5px',
  },
  modalMsgSpan: {
    color: 'primary.main',
    cursor: 'pointer',
    marginLeft: '5px',
  },
  textArea: {
    textArea: { resize: 'none' },
  },
}
export default ActionNotificationFormModal
